import { render, staticRenderFns } from "./UserChip.vue?vue&type=template&id=c2ff869e&scoped=true"
import script from "./UserChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserChip.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UserChip.vue?vue&type=style&index=0&id=c2ff869e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ff869e",
  null
  
)

export default component.exports